module.exports = __webpack_public_path__ + "static/media/loupe.5ef9b971.svg";